import type { CartData } from "/npm/@brytdesigns/shopify-hybrid-cart@0.1.29/dist/jsdelivr/types";

import { createQuery } from "/npm/@tanstack/solid-query@^5.67.1/+esm";

import client from "/npm/@brytdesigns/shopify-hybrid-cart@0.1.29/dist/jsdelivr/client.js";
import API from "/npm/@brytdesigns/shopify-hybrid-cart@0.1.29/dist/jsdelivr/api.js";

export const KEY = "cart";
export const invalidate = () => client.invalidateQueries({ queryKey: [KEY] });
export const set = (cb: (data: CartData) => CartData) =>
  client.setQueryData([KEY], cb);
export const cancel = async () => client.cancelQueries({ queryKey: [KEY] });
export const get = () => client.getQueryData([KEY]) as CartData;

export const query = createQuery(
  () => ({
    queryKey: [KEY],
    async queryFn({ signal }) {
      const cart = await API.get({}, { signal });
      if (cart?.error || !cart?.data) {
        throw cart.error;
      }
      return cart.data;
    },
    initialData: window.BrytDesigns.initialCart,
    staleTime: 1000 * 60 * 5,
    throwOnError: true,
    reconcile: "cart",
  }),
  () => client,
);
